import React from 'react';
import CloseIcon from 'components/pure/utils/icon/CloseIcon';
import TopicCoverageSelectionViewRow from './TopicCoverageSelectionViewRow';

export default class TopicCoverageSelectionView extends React.Component {
  render() {
    const {matchAny, newContext, defaultText} = this.props;
    return (
      <div className="rule-option-list rule-context-view">
        <ul>
          {matchAny &&
            matchAny.map((context, i) => (
              <li key={i}>
                <TopicCoverageSelectionViewRow
                  context={context}
                  label={i > 0 ? 'or ' : ''}
                  updateContext={newContext => this.props.updateItem(i, newContext)}
                />
                {i === matchAny.size - 1 && (
                  <div className="or-button" onClick={this.props.orClick}>
                    or
                  </div>
                )}
                <div className="delete" onClick={() => this.props.removeItem(i)}>
                  <CloseIcon />
                </div>
              </li>
            ))}
          {newContext != null && (
            <li>
              <TopicCoverageSelectionViewRow
                context={newContext}
                defaultText={defaultText}
                label={matchAny && matchAny.size > 0 ? 'or ' : ''}
              />
            </li>
          )}
        </ul>
      </div>
    );
  }
}
